import $ from 'jquery';

export default function(){
  $('.section-icon-slider_image').on('click', function() {
    $('.section-icon-slider_title').html($(this).attr('data-description'));
    $('.first .section-icon-slider_image').hide(); // Hide all images in the first section
    let index = $(this).attr('id');
    $('.first .section-icon-slider_image[id="' + index + '"]').show();
    $('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
    $(this).addClass('is-active');
    index = $(this).attr('id');
  })
  $('.first .section-icon-slider_image').hide();
  $('.first .section-icon-slider_image:first').show();

  var index = 0;
  if ($(window).width() > 768) {
    const icons = document.querySelectorAll('.section-icon-slider_block');
    $(icons[0]).find('.section-icon-slider_image').addClass('is-active');

    setInterval(function() {
      index++;
      if (index >= icons.length) {
        index = 0;
      }
      $('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
      $(icons[index]).find('.section-icon-slider_image').addClass('is-active');
      $('.section-icon-slider_title').html($(icons[index]).find('.section-icon-slider_image').attr('data-description'));

      // Change the first section's image as well
      $('.first .section-icon-slider_image').hide(); // Hide all images in the first section
      const newIndex = $(icons[index]).find('.section-icon-slider_image').attr('id');
      $('.first .section-icon-slider_image[id="' + newIndex + '"]').show(); // Show the current image in the first section
    }, 8000);

  // Register click event listeners for arrows here
  // This assumes the previous and next arrows have the classes 'prev-arrow' and 'next-arrow' respectively.
  $('.prev-arrow').on('click', function() {
    index--;
    if (index < 0) {
      index = icons.length - 1;
    }
    updateSlide();
  });

  $('.next-arrow').on('click', function() {
    index++;
    if (index >= icons.length) {
      index = 0;
    }
    updateSlide();
  });

  function updateSlide() {
    $('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
    $(icons[index]).find('.section-icon-slider_image').addClass('is-active');
    $('.section-icon-slider_title').html($(icons[index]).find('.section-icon-slider_image').attr('data-description'));

    // Change the first section's image as well
    $('.first .section-icon-slider_image').hide();
    const newIndex = $(icons[index]).find('.section-icon-slider_image').attr('id');
    $('.first .section-icon-slider_image[id="' + newIndex + '"]').show();
  }

}
  if($(window).width() <= 768) {
    $(".section-icon-slider_blocks").slick({
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    });
  }

  $('[data-icon-close]').click(function(){
    $(this).closest('[data-icon]').addClass('is-hidden').trigger('setDefaultContent');
  })

  $('[data-icon-open]').click(function(event) {
    event.preventDefault();
    var popup = $(this).data('icon-open');
    var $popup = $('[data-icon="'+ popup +'"');
    $popup.toggleClass('is-hidden');

    $('.img_embed').attr('src',$(this).data('url'));
  });

  //afterpay popup
  $('[data-afterpay-close]').click(function(){
    $('#afterpay-modal-overlay1').css('display','none');
    // $('.is-cart-open').css('overflow','auto');
  })

  $('[data-afterpay-open]').click(function(event) {
    event.preventDefault();
    var popup = $(this).data('afterpay-open');
    var $popup = $('[data-afterpay="'+ popup +'"');
    // $popup.toggleClass('is-hidden');
    // $('[data-minicart]').removeClass('is-open');
    $('#afterpay-modal-overlay1').css('display','block');
  });

  $(document).on('click', '[data-read-more]', function(){
    $(this).closest('.product-info__bottom').addClass('expanded');
  })

  $(document).on('click', '[data-read-less]', function(){
    $(this).closest('.product-info__bottom').removeClass('expanded');
  })

  $(document).on('click', '.compare-item .product-options__list .product-option__color', function(){
    var vId = $(this).attr('data-variant-id');
    var $item = $(this).closest('.compare-item');
    $item.find('[data-ajax-btn]').attr('data-id', vId);
  })

  $(document).on('click', '.compare-item a[data-link="true"]', function(e){
    e.preventDefault();
    var url = $(this).attr('href');
    var vId = $(this).closest('.compare-item').find('[data-ajax-btn]').attr('data-id');
    url += '?variant=' + vId;
    document.location.href = url;
  })

  $(document).on('click', '.compare-item .btn_learn_more[data-link="false"]', function(e){
    e.preventDefault();
    $("html, body").animate({
      scrollTop: 0
    }, 500);
  })

  $(document).on('click', '.compare-item .product_feature_title', function(){
    $(this).next('.product_features').slideToggle();
    $(this).closest('.product-item-bottom').toggleClass('expanded');
  })

}
// COOKIES CONSET (14/10/2024)
let cc_set = sessionStorage.getItem("consent");
if (cc_set != 'accepted'){
  $('#cookie_consent').show();
} else {
  $('#cookie_consent').hide();
};

$('.cookie_btn').on('click', function(){
  sessionStorage.setItem("consent", "accepted");
  $(this).closest('#cookie_consent').hide();
});

const wiggleElement = document.querySelector('.cookie_btn');
function startWiggleAnimation() {
    wiggleElement.style.animation = 'wiggle 0.7s forwards';
    // Reset the animation after 1 minute
    setTimeout(() => {
        wiggleElement.style.animation = 'none'; // Remove the animation
        setTimeout(() => {
            startWiggleAnimation(); // Restart the animation
        }, 10); // Small timeout to trigger reflow
    }, 10000); // 1 minute in milliseconds
}
// Start the animation for the first time
startWiggleAnimation();